import { parseDataForEditor } from 'scripts/helpers/util.js';

var queue = [];
var fetching = false;
var cartInitialized = false;

const queueFetch = (handle, commit) => {
  queue.push(handle);
  if (!fetching && cartInitialized) fetchNextProduct(commit);
};

const fetchNextProduct = commit => {
  fetching = true;

  if (queue.length > 0) {
    fetchProduct(commit);
  } else {
    fetching = false;
  }
};

const fetchProduct = commit => {
  let handle = queue.shift();
  let existingProduct = state.all.find(p => p.handle === handle);

  // don't fetch if this was retrieved as part of the cart products
  if (!existingProduct) {
    fetch(`/products/${handle}?view=json`)
      .then((blob) => blob.json())
      .then((response) => {
        // The .js endpoint returns the product directly, not wrapped
        console.log('Fetched product data:', response);
        let productData = parseDataForEditor(response);
        console.log('Parsed product data:', productData);
        if (productData) commit('ADD_PRODUCT', productData);
        fetchNextProduct(commit);
      })
      .catch((error) => {
        console.error('Error fetching product:', handle, error);
        fetchNextProduct(commit);
      });
  } else {
    fetchNextProduct(commit);
  }
};

const state = {
  all: [],
};

const mutations = {
  ADD_PRODUCT (state, product) {
    state.all.push(product)
  },
};

const actions = {
  init ({ state, commit }) {
    fetch('/cart?view=json')
      .then((blob) => blob.json())
      .then((response) => {
        console.log('Cart response:', response);
        let cartData = parseDataForEditor(response);
        console.log('Parsed cart data:', cartData);

        if (Array.isArray(cartData)) {
          cartData.forEach(product => {
            if (!state.all.find(p => p.handle === product.handle)) commit('ADD_PRODUCT', product)
          });
        }

        cartInitialized = true;
        fetchNextProduct(commit);
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
        cartInitialized = true;
        fetchNextProduct(commit);
      });
  },
  addProduct ({ state, commit }, handle) {
    if (queue.indexOf(handle) < 0 && !state.all.find(p => p.handle === handle)) {
      queueFetch(handle, commit);
    }
  },
};

export default {
  state,
  mutations,
  actions,
  namespaced: true,
};
